//Ejecución de funciones
document.addEventListener('DOMContentLoaded', function() {
    menuMovil();
    navegacionFija();
    submenu();
    carousel();

});

function navegacionFija() {
    const barra = document.querySelector('.nav');
    const submenu = document.querySelector('.submenu');

    //Registrar el Intersection Observer
    const observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
            barra.classList.remove('fijo');
            barra.classList.remove('nav-focus');
            barra.classList.add('nav');
            submenu.classList.remove('submenu-focus');
            submenu.classList.add('submenu');
        } else {
            barra.classList.add('fijo');
            barra.classList.add('nav-focus');
            barra.classList.remove('nav');
            submenu.classList.add('submenu-focus');
            submenu.classList.remove('submenu');
        }
    })

    //Elemento a obesrvar
    observer.observe(document.querySelector('.limit'));
}

//Función SubMenu
function submenu() {
    const submenu = document.querySelector('#submenu');
    const serv = document.querySelector('#serv');
    serv.addEventListener('mouseover', function() {
        submenu.classList.remove('hidden');

    });
    submenu.addEventListener('mouseover', function() {
        submenu.classList.remove('hidden');

    });
    serv.addEventListener('mouseout', function() {
        submenu.classList.add('hidden');

    });
    submenu.addEventListener('mouseout', function() {
        submenu.classList.add('hidden');

    });
};

//Función carrusel de logos cliente
function carousel() {
    const elementosCarrusel = document.querySelectorAll('.carousel');
    M.Carousel.init(elementosCarrusel, {
        duration: 900,
        dist: -50,
        shift: 80,
        indicators: true
    });
}

//Función Menú desplegable//
//Función Menu
function menuMovil() {
    var abierto = false;
    const listMenu = document.querySelector('.navmovil-ext');
    const menu = document.querySelector('#menu');
    menu.addEventListener('click', function() {

        if (!abierto) {
            listMenu.style.display = 'flex';
            abierto = true;
        } else {
            listMenu.style.display = 'none';
            abierto = false;
        }



    });

}